//GroupSelectExt.tsx
// добавлены арендаторы в наименование
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { useFetch } from "../../../hooks/useFetch";
import { api as groupApi } from "../../../api/groupApi";
import { Group } from "../../../types/group";
import { useTranslation } from 'react-i18next';
import { Subtenant, subtenantApi } from '../../../api/subtenantApi';

interface GroupSelectProps {
  selectedGroupId: number | null;
  onSelect: (groupId: number) => void;
}

export const GroupSelect: React.FC<GroupSelectProps> = ({ selectedGroupId, onSelect }) => {
  const { t } = useTranslation();
  
  const { data: groups } = useFetch<Group[]>(groupApi.get, []);
  const { data: subtenants } = useFetch<Subtenant[]>(subtenantApi.get, []);

  const subtenantMap = new Map<number, string>(
    subtenants.map(s => [s.subtenant_id, s.name])
  );

  const groupsExt = groups.map(g => {
    if (g.subtenant_id && subtenantMap.has(g.subtenant_id)) {
        return {...g, name: `${subtenantMap.get(g.subtenant_id)} / ${g.name}` };
    }
    return g;
  })
  .sort((a, b) => {
    const hasA = +!!(a.subtenant_id && subtenantMap.has(a.subtenant_id));
    const hasB = +!!(b.subtenant_id && subtenantMap.has(b.subtenant_id));
    // Разность даст: 0 (если оба в одной категории), -1 (если A без ID, а B с ID), 1 (наоборот)
    // Если категории разные (разность не 0), возвращаем её. Если одинаковые (0) — сортируем по алфавиту.
    return (hasA - hasB) || a.name.localeCompare(b.name);
  });  

  const handleChange = (event: SelectChangeEvent<number | ''>) => {
    const value = event.target.value;
    if (value !== '' && typeof value === 'number') {
      onSelect(value);
    }
  };

  // Щоб MUI Select працював коректно, використовуємо `number | ''` для значення,
  // де '' представляє `null` (нічого не вибрано)
  const selectValue = selectedGroupId ?? '';

  return (
    <FormControl fullWidth>
      {/* <InputLabel id="group-select-label">Група</InputLabel> */}
      <Select<number | ''>
        labelId="group-select-label"
        id="group-select"
        value={selectValue}
        // label="Група"
        onChange={handleChange}
        // Дозволяє вибирати "порожній" елемент, якщо selectedGroupId === null
        displayEmpty 
      >
        <MenuItem value="" disabled>
          {t('GroupSelect.SelectGroup')}
        </MenuItem>
        {groupsExt.map((group) => (
          <MenuItem 
            key={group.group_id} 
            value={group.group_id}
          >
            {group.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};